import React from 'react';
import { useTranslation } from 'react-i18next';
import Tag from 'components/Tag';
import { EXTRAS } from 'utils/constants/jobDetails';

const LoadDetailsSideItem = ({ label, quantity }) => {
  return (
    <div className="load-details-side__item">
      <div className="load-details-side__label">{label}</div>
      <div className="load-details-side__quantity">{quantity}</div>
    </div>
  );
};

const LoadDetailsSide = ({
  className,
  numberOfItems,
  mass,
  height,
  extras
}) => {
  const { t } = useTranslation('DatesUnits');

  const renderExtrasTags = () => {
    return extras
      .filter(item => !!EXTRAS[item])
      .map((extra, index) => {
        return (
          <div
            className="load-details-side__extra"
            key={`side-extra-tag-${index}`}
          >
            <Tag
              text={t(
                `Offers:${
                  extra === EXTRAS.HANDLING_LOADING ||
                  extra === EXTRAS.HANDLING_UNLOADING
                    ? EXTRAS.HANDLING
                    : extra
                }`
              )}
              skin="blue"
            />
          </div>
        );
      });
  };
  return (
    <div className={className} data-testid="load-details-side">
      <div className="load-details-side">
        <div className="load-details-side__row">
          <LoadDetailsSideItem
            label={t('numberPallets')}
            quantity={`${numberOfItems} Eu`}
          />
          <LoadDetailsSideItem label={t('maxWeight')} quantity={`${mass} kg`} />
          <LoadDetailsSideItem
            label={t('maxHeight')}
            quantity={`${height / 100} m`}
          />
        </div>
        {extras && (
          <div className="load-details-side__row load-details-side__row--wrap">
            {renderExtrasTags()}
          </div>
        )}
      </div>
    </div>
  );
};
export default LoadDetailsSide;
